import { gql } from '@apollo/client'
import { PERMISSIONS_FRAGMENT } from 'graphql/securityProfiles/queries'

export const USER_ME_QUERY = gql`
  query USER_ME_QUERY {
    userMe {
      data {
        id
        companyId
        email
        firstName
        lastName
        displayName
        avatarUrl
        roles
        status
        timezone
        username
        refreshTokenAbsoluteTtl
        idleTimeoutSeconds
        positions {
          id
          description
        }
        company {
          id
          name
          currency
          licences
          logoUrl
          domainName
          refreshTokenAbsoluteTtl
          idleTimeoutSeconds
        }
        securityGroups {
          id
          name
          active
          businessRules {
            users {
              userOrPositionId
              securityProfileId
            }
            views {
              canView
              riskTemplateId
            }
          }
        }
        permissionsFromSecurityGroups {
          ...PERMISSIONS
        }
        controlledIds
        userAndPositionIds
      }
    }
  }
  ${PERMISSIONS_FRAGMENT}
`

export const USERS_LIST_QUERY = gql`
  query USERS_LIST_QUERY($filter: UserFilter, $order: OrderInput, $pagination: PaginationInput) {
    settingsUsers(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        companyId
        email
        firstName
        lastName
        dateOfBirth
        mobilePhone
        roles
        username
        displayName
        active
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`

export const USERS_SELECT_QUERY = gql`
  query USERS_SELECT_QUERY($filter: UserFilter, $order: OrderInput, $pagination: PaginationInput) {
    users(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        active
        firstName
        lastName
        companyId
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`

export const USERS_DETAILS_QUERY = gql`
  query USERS_DETAILS_QUERY($filter: UserFilter, $order: OrderInput, $pagination: PaginationInput) {
    settingsUsers(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        active
        mobilePhone
        language
        email
        lastName
        timezone
        companyId
        homePhone
        workPhone
        firstName
        displayName
        code
        companyId
        reportsToId
        avatarUrl
        middleName
        alternateEmail
        dateOfBirth
        positions {
          id
          description
        }
        businessUnits {
          id
          description
        }
        reportsTo {
          id
          firstName
          lastName
        }
        address
        roles
        status
        gender
        employmentStatus
        authMethod
        password
        username
        totpEnabled
        externalEmployeeId
        activeDirectoryId
        activeDirectoryTenantId
        activeDirectoryAdministrativeUnits {
          id
          displayName
        }
        locations {
          id
          description
          geoLocation {
            address
          }
        }
        refreshTokenAbsoluteTtl
        idleTimeoutSeconds
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`

export const USERS_LOOKUP_DETAILS_QUERY = gql`
  query USERS_LOOKUP_DETAILS_QUERY($filter: UserFilter, $order: OrderInput, $pagination: PaginationInput) {
    users(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        externalEmployeeId
        email
        workPhone
        locations {
          id
          description
          geoLocation {
            city
            state
            country
            address
          }
        }
      }
    }
  }
`

export const USERS_OR_POSITIONS_QUERY = gql`
  query USERS_OR_POSITIONS_QUERY($filter: UsersOrPositionsFilter, $pagination: PaginationInput) {
    usersOrPositions(filter: $filter, pagination: $pagination) {
      data {
        ... on User {
          id
          firstName
          lastName
          avatarUrl
          displayName
        }
        ... on Position {
          id
          description
          userId
        }
      }
    }
  }
`
